import { CardType } from '@/components/v3/atoms/card/card'

export const getCardHref = (type: CardType, path: string): string => {
  if (type === 'Supplier') return `/wedding-suppliers/${path}`
  if (type === 'Venue') return `/wedding-venues/${path}`
  return path
}
